module.exports = __webpack_public_path__ + "img/num6.8382f698.svg";